module.exports = __webpack_public_path__ + "img/product_advantages_2.3cb544aa.png";